import PayoutToken from '@apps/maha/admin/tokens/payout'
import Panel from '@admin/components/panel'
import React from 'react'
const mapPropsToPanel = (props, context) => ({
  title: 't(Teams)',
  collection: {
    endpoint: '/api/admin/team/affiliate/payouts',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Payout)', key: 'date', primary: true, format: (payout) => (
        <PayoutToken payout={ payout } />
      ) },
      { label: 't(Payments)', key: 'payments_count', collapsing: true, align: 'right' },
      { label: 't(Commision)', key: 'total', collapsing: true, align: 'right', format: 'currency' }
    ],
    empty: {
      title: 't(No Payouts)',
      text: 't(You have not been issued any payouts)',
      svg: 'hand_coins'
    },
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' }
  }
})

export default Panel(null, mapPropsToPanel)
